module.exports = __webpack_public_path__ + "images/bg-img-start_f30e78a41e500b75fd9f93b8912c70c7.png";